(() => {
  if (window.jobskiSyncPickupSize) return;
  const root = window.Shopify?.routes?.root || '/';
  const bundles = new Set(["champion-golden-pheasamt","preorder-american-dream-ginger-fox","pakiet-ginger-fox-balsam-olejek","pakiet-american-dream-balsam-olejek","pakiet-golden-pheasant-serum-balsam","pakiet-ginger-fox-american-dream-balsamy","pakiet-ginger-fox-golden-pheasant-balsamy"]);
  window.jobskiPickupUnits = cart => cart.items.reduce((sum, item) => sum + (item.requires_shipping ? item.quantity * (bundles.has(item.handle) ? 2 : 1) : 0), 0);
  let pending;
  let timer;
  window.jobskiSyncPickupSize = async () => {
    if (pending) await pending;
    pending = (async () => {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 12000);
      try {
        const response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
        if (!response.ok) throw new Error('cart');
        const cart = await response.json();
        const attributes = cart.attributes || {};
        const nativePoint = attributes['BLPaczka PUDO Point Number'];
        const nativeCourier = attributes['BLPaczka PUDO Point Courier'] || '';
        const size = cart.requires_shipping === false || !window.jobskiPickupUnits(cart) ? '' : (window.jobskiPickupUnits(cart) >= 6 ? 'B' : 'A');
        const updates = { 'InPost gabaryt': size };
        if (nativePoint && nativeCourier.startsWith('paczkomaty')) {
          updates['InPost Paczkomat'] = nativePoint;
          updates['InPost adres'] = attributes['BLPaczka PUDO Point Description'] || '';
        }
        if (Object.entries(updates).every(([key, value]) => (attributes[key] || '') === value)) return cart;
        const saved = await fetch(root + 'cart/update.js', {
          method: 'POST', credentials: 'same-origin', signal: controller.signal,
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: updates })
        });
        if (!saved.ok) throw new Error('cart');
        const result = await saved.json();
        if ((result.attributes?.['InPost gabaryt'] || '') !== size) throw new Error('size');
        return result;
      } finally { clearTimeout(timeout); }
    })();
    const current = pending;
    try { return await current; } finally { if (pending === current) pending = null; }
  };
  const schedule = () => {
    clearTimeout(timer);
    timer = setTimeout(() => window.jobskiSyncPickupSize().catch(() => {}), 300);
  };
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
  document.addEventListener('cart:lines-update', schedule);
  document.addEventListener('jobski:pickup-selected', schedule);
  window.addEventListener('message', event => {
    if (['https://send.blpaczka.com', 'https://api.blpaczka.com'].includes(event.origin) && event.data?.type === 'SELECT_CHANGE') schedule();
  });
  window.addEventListener('pageshow', schedule);
  schedule();
})();

if (!customElements.get('jobski-pickup')) {
  customElements.define('jobski-pickup', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.onSelection = event => this.updateSelection(event.detail);
      document.addEventListener('jobski:pickup-selected', this.onSelection);
      this.input = this.querySelector('input');
      this.status = this.querySelector('[data-status]');
      this.results = this.querySelector('[data-results]');
      this.more = this.querySelector('[data-more]');
      this.querySelector('[data-search]').addEventListener('click', () => this.search(false));
      this.input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') { event.preventDefault(); this.search(false); }
      });
      this.more.addEventListener('click', () => this.search(true));
      this.querySelector('[data-clear]').addEventListener('click', () => this.save(null));
    }
    disconnectedCallback() {
      this.controller?.abort();
      document.removeEventListener('jobski:pickup-selected', this.onSelection);
      this.ready = false;
    }
    updateSelection({ name, address }) {
      this.querySelector('[data-point]').textContent = name;
      this.querySelector('[data-address]').textContent = address;
      this.querySelector('[data-selected]').hidden = !name;
      const summary = this.closest('details')?.querySelector('[data-pickup-summary]');
      if (summary) summary.textContent = name ? this.dataset.selectedLabel + ' ' + name : this.dataset.summaryHint;
    }
    message(text) { this.status.textContent = text; }
    async search(next) {
      const query = this.input.value.trim();
      if (query.length < 2) { this.message(this.dataset.shortQuery || this.dataset.empty); this.input.focus(); return; }
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      if (!next || this.lastQuery !== query) { this.page = 1; this.results.replaceChildren(); }
      else this.page += 1;
      this.lastQuery = query;
      this.more.hidden = true;
      this.message(this.dataset.loading);
      this.results.setAttribute('aria-busy', 'true');
      const params = new URLSearchParams({ type: 'parcel_locker', functions: 'parcel_collect', per_page: '20', page: String(this.page) });
      if (/^\d{2}-?\d{3}$/.test(query)) params.set('post_code', query.replace(/^(\d{2})-?(\d{3})$/, '$1-$2'));
      else if (/^(?:[a-z]{2,5}\d{1,5}[a-z]*|POP-[a-z0-9-]+)$/i.test(query)) params.set('name', query.toUpperCase());
      else params.set('city', query);
      const requestController = this.controller;
      let timedOut = false;
      const timer = setTimeout(() => { timedOut = true; requestController.abort(); }, 15000);
      try {
        const response = await fetch('https://api-shipx-pl.easypack24.net/v1/points?' + params, { signal: this.controller.signal, credentials: 'omit', referrerPolicy: 'no-referrer' });
        if (!response.ok) throw new Error('points');
        const data = await response.json();
        if (requestController !== this.controller || !this.isConnected) return;
        const points = (data.items || []).filter(point => point.status === 'Operating' && point.type?.includes('parcel_locker') && point.functions?.includes('parcel_collect'));
        for (const point of points) this.renderPoint(point);
        this.message(this.results.children.length ? '' : this.dataset.empty);
        this.more.hidden = this.page >= Number(data.total_pages || data.meta?.total_pages || 1);
      } catch (error) {
        if (requestController === this.controller && (error.name !== 'AbortError' || timedOut)) { this.message(this.dataset.error); if (next) this.page -= 1; }
      } finally {
        clearTimeout(timer);
        if (requestController === this.controller) this.results.removeAttribute('aria-busy');
      }
    }
    renderPoint(point) {
      const row = document.createElement('li');
      const heading = document.createElement('h3');
      heading.textContent = point.display_name || 'InPost ' + point.name;
      row.append(heading);
      for (const value of [point.address?.line1, point.address?.line2, point.location_description, point.opening_hours ? this.dataset.hours + ' ' + point.opening_hours : '', point.physical_type_mapped === '006' ? point.physical_type_description : '']) {
        if (!value) continue;
        const p = document.createElement('p'); p.textContent = value; row.append(p);
      }
      const button = document.createElement('button');
      button.type = 'button'; button.textContent = this.dataset.choose + ' ' + point.name;
      button.addEventListener('click', () => this.save(point));
      row.append(button); this.results.append(row);
    }
    async save(point) {
      if (this.saving) return;
      this.saving = true;
      this.message(this.dataset.saving);
      const checkoutButtons = [...document.querySelectorAll('[name="checkout"]')];
      const enabledCheckout = checkoutButtons.filter(button => !button.disabled);
      enabledCheckout.forEach(button => { button.disabled = true; });
      const name = point?.name || '';
      const address = point ? [point.address?.line1, point.address?.line2].filter(Boolean).join(', ') : '';
      const saveController = new AbortController();
      const saveTimer = setTimeout(() => saveController.abort(), 12000);
      try {
        const cartResponse = await fetch(this.dataset.updateUrl.replace(/\/update\.js$/, '.js'), { credentials: 'same-origin', signal: saveController.signal, cache: 'no-store' });
        if (!cartResponse.ok) throw new Error('cart');
        const currentCart = await cartResponse.json();
        const units = window.jobskiPickupUnits(currentCart);
        const response = await fetch(this.dataset.updateUrl, { method: 'POST', signal: saveController.signal, credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { 'InPost Paczkomat': name, 'InPost adres': address, 'InPost gabaryt': name ? (units >= 6 ? 'B' : 'A') : '' } }) });
        if (!response.ok) throw new Error('cart');
        const cart = await response.json();
        if (name && cart.attributes?.['InPost Paczkomat'] !== name) throw new Error('save');
        document.dispatchEvent(new CustomEvent('jobski:pickup-selected', { detail: { name, address } }));
        this.message(point ? this.dataset.saved : this.dataset.cleared);
        this.results.replaceChildren(); this.more.hidden = true;
      } catch (_) { this.message(this.dataset.error); }
      finally { clearTimeout(saveTimer); this.saving = false; enabledCheckout.forEach(button => { button.disabled = false; }); }
    }
  });
}

